angular.module('app') .directive('closeOnSelect', function () { 
    return { 
        restrict: 'A',
        require: 'mdAutocomplete',
        link: function(scope, element, attrs, ctrl) { 
            var closeOnSelect = function(newItem) {
                if(newItem != null) {
                    element.find('input').blur();
                }
            };
            ctrl.registerSelectedItemWatcher(closeOnSelect);
        } 
    };
});
